import React, { useMemo } from 'react';
import propTypes from 'prop-types';
import { UiTable } from 'src/ui';

export function ComplianceSummaryTable({ loading, data }) {
  const tableColumns = useMemo(
    () => [
      {
        Header: 'Account',
        accessor: 'account',
        Cell: row => <div className="account-name">{row.value}</div>,
      },
      {
        Header: 'Passes',
        accessor: 'passed',
        className: 'green',
        width: 85,
        Cell: row => <div>{row.value}</div>,
      },
      {
        Header: 'Needs Review',
        accessor: 'needsReview',
        className: 'yellow',
        width: 128,
        Cell: row => <div>{row.value}</div>,
      },
      {
        Header: 'Failures',
        accessor: 'failed',
        className: 'red',
        width: 95,
        Cell: row => <div>{row.value}</div>,
      },
      {
        Header: 'Total',
        accessor: 'total',
        width: 78,
        Cell: row => <div>{row.value}</div>,
      },
    ],
    []
  );
  return (
    <>
      <UiTable
        className="compliance-summary-table"
        columns={tableColumns}
        loading={loading}
        data={data}
        getTheadThProps={() => ({
          className: 'has-text-left',
        })}
        title="Account Summary"
        hideNext
        hidePrev
        hideNoDataComponent
        minRows={1}
      />
    </>
  );
}

ComplianceSummaryTable.propTypes = {
  loading: propTypes.bool.isRequired,
  data: propTypes.arrayOf(propTypes.object).isRequired,
};
